module.exports = __webpack_public_path__ + "img/HQ-PA2W1UH.a9cfd432.jpg";